import React, { useState } from "react";

import { useTranslation } from "utils";

import { Icon, Popover, SocialShareButtons, Tooltip, Message as message } from "components";

const Content = ({ title, setVisible, share }) => (
  <div className="shareTooltip">
    <div className="title-row">
      <h5 className="white-text">{title}</h5>
      <Icon className="pointer" iconName="tabler/x" onClick={() => setVisible(false)} />
    </div>
    <div style={{ marginRight: "1.75rem", marginTop: "1rem" }}>
      <SocialShareButtons color="#FFFFFF" url={share ? share.link : ""} text={share ? share.title : ""} />
    </div>
  </div>
);

export const SocialSharePopover = ({ title, share, saved, iconSize, dataTestId, className }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  /* eslint no-unneeded-ternary: "error" */
  const contentTitle = title ? title : t("global:share.share");
  const handleClick = async () => {
    if (window.cordova && window.cordova.plugins.socialsharing) {
      return window.cordova.plugins.socialsharing.shareWithOptions(
        {
          url: share.link,
          message: share.title,
          subject: share.title,
        },
        () => {
          message({ content: t?.("share.successful"), icon: "tick" });
        },
        () => {
          // an actual error
          message({ content: t?.("share.failed"), icon: "error" });
          setVisible(!visible);
        }
      );
    }

    if (navigator && navigator.share) {
      return navigator
        .share({
          title: share && share.title ? share.title : "",
          url: share.link,
        })
        .then(() => {
          message({ content: t?.("share.successful"), icon: "tick" });
        })
        .catch((_err) => {
          // possibly an actual error
          if (_err.name !== "AbortError") {
            message({ content: t?.("share.failed"), icon: "error" });
            setVisible(!visible);
          }
        });
    }

    setVisible(!visible);
  };

  return (
    <Popover
      className={`share-popover ${saved ? "starred" : ""}`}
      content={<Content title={contentTitle} share={share} t={t} setVisible={setVisible} />}
      placement={window.innerWidth > 1348 ? "bottom" : "bottomRight"}
      trigger="click"
      visible={visible}
      dataTestId={`${dataTestId}-social-share-popover`}
    >
      <Tooltip placement="bottom" title={contentTitle}>
        <Icon
          dataTestId={`${dataTestId}-social-share-icon`}
          className={`pointer ${className}`}
          iconName="tabler/share"
          onClick={handleClick}
          size={iconSize}
        ></Icon>
      </Tooltip>
    </Popover>
  );
};
